import type { Lang } from '../types';

export interface HomeText {
  pageTitle: string;
  loadingReservations: string;
  welcomeTitle: string;
  welcomeLogin: string;
  prevDay: string;
  prev3Days: string;
  prev5Days: string;
  prevDayShort: string;
  prev3DaysShort: string;
  prev5DaysShort: string;
  today: string;
  nextDay: string;
  next3Days: string;
  next5Days: string;
  viewDay: string;
  view3Days: string;
  view5Days: string;
  perPage: string;
  addReservation: string;
  conflicts: string;
  compact: string;
  ongoing: string;
  incoming: string;
  newReservationTitle: string;
  formApartment: string;
  formGuestName: string;
  formCheckInDate: string;
  formCheckOutDate: string;
  formNumberOfGuests: string;
  formNotes: string;
  selectApartment: string;
  reservationCreated: string;
  reservationsTitle: (count: number) => string;
  showing: (shown: number, total: number) => string;
  pageInfo: (page: number, total: number) => string;
  ongoingReservations: string;
  incomingReservations: string;
  noReservationsDay: string;
  noReservations3Day: string;
  noReservations5Day: string;
  noReservationsAddHint: string;
  inactiveConflict: string;
  tableGuest: string;
  tableApartment: string;
  tableCheckIn: string;
  tableCheckOut: string;
  tableDates: string;
  tableGuests: string;
  tableGuestbook: string;
  tableUbyport: string;
  tableStatus: string;
  tableManage: string;
  tableForm: string;
  tableEdit: string;
  tableActions: string;
  manage: string;
  form: string;
  inactiveLabel: string;
  ubyportUnavailableTitle: string;
  ubyportUnavailableBody: string;
  statusCompleted: string;
  statusIncomplete: string;
  statusDeprecated: string;
  statusNotFilled: string;
  statusSent: string;
  statusSending: string;
  statusFailed: string;
  statusUnavailable: string;
  statusPartial: string;
  statusNotSent: string;
  cityTaxPaidLabel: string;
  cityTaxUnpaidLabel: string;
  errorInactiveForm: string;
  errorNoFormUrl: string;
  cancelledLabel: string;
  deprecatedLabel: string;
  dateLocale: string;
  emptyNoApartmentsTitle: string;
  emptyNoApartmentsBody: string;
  emptyNoApartmentsCta: string;
  calendarSyncHint: string;
  calendarSyncLink: string;
}

export const homeText: Record<Lang, HomeText> = {
  cs: {
    pageTitle: 'Přehled rezervací',
    loadingReservations: 'Načítám rezervace…',
    welcomeTitle: 'Vítejte v Guestbook',
    welcomeLogin: 'Přihlaste se pro zobrazení rezervací.',
    prevDay: '< Předchozí den',
    prev3Days: '< Předchozí 3 dny',
    prev5Days: '< Předchozích 5 dní',
    prevDayShort: '< Předch. den',
    prev3DaysShort: '< Předch. 3 dny',
    prev5DaysShort: '< Předch. 5 dní',
    today: 'Dnes',
    nextDay: 'Následující den >',
    next3Days: 'Následující 3 dny >',
    next5Days: 'Následujících 5 dní >',
    viewDay: '1 den',
    view3Days: '3 dny',
    view5Days: '5 dní',
    perPage: 'na stránku',
    addReservation: 'Přidat rezervaci',
    conflicts: 'Konflikty',
    compact: 'Kompaktní',
    ongoing: 'Probíhající',
    incoming: 'Nadcházející',
    newReservationTitle: 'Nová rezervace',
    formApartment: 'Apartmán',
    formGuestName: 'Jméno hosta',
    formCheckInDate: 'Datum příjezdu',
    formCheckOutDate: 'Datum odjezdu',
    formNumberOfGuests: 'Počet hostů',
    formNotes: 'Poznámky',
    selectApartment: 'Vyberte apartmán',
    reservationCreated: 'Rezervace vytvořena',
    reservationsTitle: (count) => `Rezervace (${count})`,
    showing: (shown, total) => `Zobrazuji ${shown} z ${total}`,
    pageInfo: (page, total) => `(Stránka ${page} z ${total})`,
    ongoingReservations: 'Probíhající rezervace',
    incomingReservations: 'Nadcházející rezervace',
    noReservationsDay: 'Pro tento den nejsou žádné rezervace.',
    noReservations3Day: 'Pro toto 3denní období nejsou žádné rezervace.',
    noReservations5Day: 'Pro toto 5denní období nejsou žádné rezervace.',
    noReservationsAddHint: 'Klikněte na „Přidat rezervaci" pro vytvoření.',
    inactiveConflict: 'Neaktivní — konflikt přebukování',
    tableGuest: 'Host',
    tableApartment: 'Apartmán',
    tableCheckIn: 'Příjezd',
    tableCheckOut: 'Odjezd',
    tableDates: 'Termín',
    tableGuests: 'hostů',
    tableGuestbook: 'Guestbook',
    tableUbyport: 'Ubyport',
    tableStatus: 'Stav',
    tableManage: 'Správa',
    tableForm: 'Formulář',
    tableEdit: 'Upravit',
    tableActions: 'Akce',
    manage: 'Správa',
    form: 'Formulář',
    inactiveLabel: 'Neaktivní',
    ubyportUnavailableTitle: 'Ubyport je momentálně nedostupný.',
    ubyportUnavailableBody: 'Registrace hostů nelze momentálně odesílat. Systém automaticky opakuje neúspěšné odesílání.',
    statusCompleted: 'DOKONČENO',
    statusIncomplete: 'NEDOKONČENO',
    statusDeprecated: 'ARCHIVOVÁNO',
    statusNotFilled: 'NEVYPLNĚNO',
    statusSent: 'ODESLÁNO',
    statusSending: 'ODESÍLÁM',
    statusFailed: 'SELHALO',
    statusUnavailable: 'NEDOSTUPNÉ',
    statusPartial: 'ČÁSTEČNÉ',
    statusNotSent: 'NEODESLÁNO',
    cityTaxPaidLabel: 'Zaplaceno',
    cityTaxUnpaidLabel: 'Nezaplaceno',
    errorInactiveForm: 'Tato rezervace je neaktivní kvůli konfliktu přebukování. Aktivujte ji na stránce Konflikty.',
    errorNoFormUrl: 'Nelze otevřít URL formuláře pro tuto rezervaci.',
    cancelledLabel: 'Zrušeno',
    deprecatedLabel: 'Zastaralé',
    dateLocale: 'cs-CZ',
    emptyNoApartmentsTitle: 'Vítejte v Guestbooku!',
    emptyNoApartmentsBody: 'Zatím nemáte přidaný žádný apartmán. Přidejte první apartmán a začněte přijímat rezervace a spravovat hosty.',
    emptyNoApartmentsCta: 'Přidat první apartmán →',
    calendarSyncHint: 'Tip: Synchronizujte rezervační kalendář (Airbnb, Booking.com…) a rezervace se zobrazí automaticky.',
    calendarSyncLink: 'Propojení kalendáře →',
  },
  en: {
    pageTitle: 'Reservations Dashboard',
    loadingReservations: 'Loading reservations...',
    welcomeTitle: 'Welcome to Guestbook',
    welcomeLogin: 'Please login to view your reservations.',
    prevDay: '< Previous Day',
    prev3Days: '< Previous 3 Days',
    prev5Days: '< Previous 5 Days',
    prevDayShort: '< Prev Day',
    prev3DaysShort: '< Prev 3 Days',
    prev5DaysShort: '< Prev 5 Days',
    today: 'Today',
    nextDay: 'Next Day >',
    next3Days: 'Next 3 Days >',
    next5Days: 'Next 5 Days >',
    viewDay: '1 Day',
    view3Days: '3 Days',
    view5Days: '5 Days',
    perPage: 'per page',
    addReservation: 'Add Reservation',
    conflicts: 'Conflicts',
    compact: 'Compact',
    ongoing: 'Ongoing',
    incoming: 'Incoming',
    newReservationTitle: 'New Reservation',
    formApartment: 'Apartment',
    formGuestName: 'Guest Name',
    formCheckInDate: 'Check-in Date',
    formCheckOutDate: 'Check-out Date',
    formNumberOfGuests: 'Number of Guests',
    formNotes: 'Notes',
    selectApartment: 'Select apartment',
    reservationCreated: 'Reservation created',
    reservationsTitle: (count) => `Reservations (${count})`,
    showing: (shown, total) => `Showing ${shown} of ${total}`,
    pageInfo: (page, total) => `(Page ${page} of ${total})`,
    ongoingReservations: 'Ongoing Reservations',
    incomingReservations: 'Incoming Reservations',
    noReservationsDay: 'No reservations for this day.',
    noReservations3Day: 'No reservations for this 3-day period.',
    noReservations5Day: 'No reservations for this 5-day period.',
    noReservationsAddHint: 'Click "Add Reservation" to create one.',
    inactiveConflict: 'Inactive — overbooking conflict',
    tableGuest: 'Guest',
    tableApartment: 'Apartment',
    tableCheckIn: 'Check-in',
    tableCheckOut: 'Check-out',
    tableDates: 'Dates',
    tableGuests: 'guests',
    tableGuestbook: 'Guestbook',
    tableUbyport: 'Ubyport',
    tableStatus: 'Status',
    tableManage: 'Manage',
    tableForm: 'Form',
    tableEdit: 'Edit',
    tableActions: 'Actions',
    manage: 'Manage',
    form: 'Form',
    inactiveLabel: 'Inactive',
    ubyportUnavailableTitle: 'Ubyport is currently unavailable.',
    ubyportUnavailableBody: 'Guest registrations cannot be submitted at this time. The system will automatically retry any failed submissions.',
    statusCompleted: 'COMPLETED',
    statusIncomplete: 'INCOMPLETE',
    statusDeprecated: 'DEPRECATED',
    statusNotFilled: 'NOT FILLED',
    statusSent: 'SENT',
    statusSending: 'SENDING',
    statusFailed: 'FAILED',
    statusUnavailable: 'UNAVAILABLE',
    statusPartial: 'PARTIAL',
    statusNotSent: 'NOT SENT',
    cityTaxPaidLabel: 'Paid',
    cityTaxUnpaidLabel: 'Unpaid',
    errorInactiveForm: 'This reservation is inactive due to an overbooking conflict. Toggle it active on the Conflicts page first.',
    errorNoFormUrl: 'Unable to open guest form URL for this reservation.',
    cancelledLabel: 'Cancelled',
    deprecatedLabel: 'Deprecated',
    dateLocale: 'en-US',
    emptyNoApartmentsTitle: 'Welcome to Guestbook!',
    emptyNoApartmentsBody: 'You have no apartments yet. Add your first apartment to start accepting reservations and managing guests.',
    emptyNoApartmentsCta: 'Add your first apartment →',
    calendarSyncHint: 'Tip: Sync your booking calendar (Airbnb, Booking.com…) and reservations will appear automatically.',
    calendarSyncLink: 'Calendar settings →',
  },
  vi: {
    pageTitle: 'Tổng quan lịch đặt',
    loadingReservations: 'Đang tải lịch đặt…',
    welcomeTitle: 'Chào mừng đến Guestbook',
    welcomeLogin: 'Vui lòng đăng nhập để xem lịch đặt.',
    prevDay: '< Ngày trước',
    prev3Days: '< 3 ngày trước',
    prev5Days: '< 5 ngày trước',
    prevDayShort: '< Tr. đó',
    prev3DaysShort: '< 3 ngày tr.',
    prev5DaysShort: '< 5 ngày tr.',
    today: 'Hôm nay',
    nextDay: 'Ngày tiếp >',
    next3Days: '3 ngày tiếp >',
    next5Days: '5 ngày tiếp >',
    viewDay: '1 Ngày',
    view3Days: '3 Ngày',
    view5Days: '5 Ngày',
    perPage: 'mỗi trang',
    addReservation: 'Thêm lịch đặt',
    conflicts: 'Xung đột',
    compact: 'Gọn',
    ongoing: 'Đang diễn ra',
    incoming: 'Sắp tới',
    newReservationTitle: 'Lịch đặt mới',
    formApartment: 'Căn hộ',
    formGuestName: 'Tên khách',
    formCheckInDate: 'Ngày nhận phòng',
    formCheckOutDate: 'Ngày trả phòng',
    formNumberOfGuests: 'Số lượng khách',
    formNotes: 'Ghi chú',
    selectApartment: 'Chọn căn hộ',
    reservationCreated: 'Đã tạo lịch đặt',
    reservationsTitle: (count) => `Lịch đặt (${count})`,
    showing: (shown, total) => `Hiển thị ${shown} / ${total}`,
    pageInfo: (page, total) => `(Trang ${page} / ${total})`,
    ongoingReservations: 'Lịch đặt đang diễn ra',
    incomingReservations: 'Lịch đặt sắp tới',
    noReservationsDay: 'Không có lịch đặt nào trong ngày này.',
    noReservations3Day: 'Không có lịch đặt nào trong 3 ngày này.',
    noReservations5Day: 'Không có lịch đặt nào trong 5 ngày này.',
    noReservationsAddHint: 'Nhấn "Thêm lịch đặt" để tạo mới.',
    inactiveConflict: 'Không hoạt động — xung đột lịch đặt',
    tableGuest: 'Khách',
    tableApartment: 'Căn hộ',
    tableCheckIn: 'Nhận phòng',
    tableCheckOut: 'Trả phòng',
    tableDates: 'Ngày',
    tableGuests: 'khách',
    tableGuestbook: 'Guestbook',
    tableUbyport: 'Ubyport',
    tableStatus: 'Trạng thái',
    tableManage: 'Quản lý',
    tableForm: 'Biểu mẫu',
    tableEdit: 'Sửa',
    tableActions: 'Hành động',
    manage: 'Quản lý',
    form: 'Biểu mẫu',
    inactiveLabel: 'Không hoạt động',
    ubyportUnavailableTitle: 'Ubyport hiện không khả dụng.',
    ubyportUnavailableBody: 'Không thể gửi đăng ký khách lúc này. Hệ thống sẽ tự động thử lại.',
    statusCompleted: 'HOÀN THÀNH',
    statusIncomplete: 'CHƯA XONG',
    statusDeprecated: 'LƯU TRỮ',
    statusNotFilled: 'CHƯA ĐIỀN',
    statusSent: 'ĐÃ GỬI',
    statusSending: 'ĐANG GỬI',
    statusFailed: 'THẤT BẠI',
    statusUnavailable: 'KHÔNG KHẢ DỤNG',
    statusPartial: 'MỘT PHẦN',
    statusNotSent: 'CHƯA GỬI',
    cityTaxPaidLabel: 'Đã thanh toán',
    cityTaxUnpaidLabel: 'Chưa thanh toán',
    errorInactiveForm: 'Lịch đặt này không hoạt động do xung đột. Hãy kích hoạt nó trên trang Xung đột trước.',
    errorNoFormUrl: 'Không thể mở URL biểu mẫu cho lịch đặt này.',
    cancelledLabel: 'Đã hủy',
    deprecatedLabel: 'Đã lỗi thời',
    dateLocale: 'vi-VN',
    emptyNoApartmentsTitle: 'Chào mừng đến Guestbook!',
    emptyNoApartmentsBody: 'Bạn chưa có căn hộ nào. Thêm căn hộ đầu tiên để bắt đầu nhận lịch đặt và quản lý khách.',
    emptyNoApartmentsCta: 'Thêm căn hộ đầu tiên →',
    calendarSyncHint: 'Mẹo: Đồng bộ lịch đặt phòng (Airbnb, Booking.com…) và lịch đặt sẽ tự động hiển thị.',
    calendarSyncLink: 'Cài đặt lịch →',
  },
  uk: {
    pageTitle: 'Панель бронювань',
    loadingReservations: 'Завантаження бронювань…',
    welcomeTitle: 'Ласкаво просимо до Guestbook',
    welcomeLogin: 'Будь ласка, увійдіть для перегляду бронювань.',
    prevDay: '< Попередній день',
    prev3Days: '< Попередні 3 дні',
    prev5Days: '< Попередні 5 днів',
    prevDayShort: '< Поп. день',
    prev3DaysShort: '< Поп. 3 дні',
    prev5DaysShort: '< Поп. 5 днів',
    today: 'Сьогодні',
    nextDay: 'Наступний день >',
    next3Days: 'Наступні 3 дні >',
    next5Days: 'Наступні 5 днів >',
    viewDay: '1 день',
    view3Days: '3 дні',
    view5Days: '5 днів',
    perPage: 'на сторінку',
    addReservation: 'Додати бронювання',
    conflicts: 'Конфлікти',
    compact: 'Компактно',
    ongoing: 'Поточні',
    incoming: 'Майбутні',
    newReservationTitle: 'Нове бронювання',
    formApartment: 'Апартамент',
    formGuestName: 'Ім\'я гостя',
    formCheckInDate: 'Дата заїзду',
    formCheckOutDate: 'Дата виїзду',
    formNumberOfGuests: 'Кількість гостей',
    formNotes: 'Нотатки',
    selectApartment: 'Оберіть апартамент',
    reservationCreated: 'Бронювання створено',
    reservationsTitle: (count) => `Бронювання (${count})`,
    showing: (shown, total) => `Показано ${shown} з ${total}`,
    pageInfo: (page, total) => `(Сторінка ${page} з ${total})`,
    ongoingReservations: 'Поточні бронювання',
    incomingReservations: 'Майбутні бронювання',
    noReservationsDay: 'Немає бронювань на цей день.',
    noReservations3Day: 'Немає бронювань на цей 3-денний період.',
    noReservations5Day: 'Немає бронювань на цей 5-денний період.',
    noReservationsAddHint: 'Натисніть «Додати бронювання» для створення.',
    inactiveConflict: 'Неактивне — конфлікт перебронювання',
    tableGuest: 'Гість',
    tableApartment: 'Апартамент',
    tableCheckIn: 'Заїзд',
    tableCheckOut: 'Виїзд',
    tableDates: 'Дати',
    tableGuests: 'гостей',
    tableGuestbook: 'Guestbook',
    tableUbyport: 'Ubyport',
    tableStatus: 'Статус',
    tableManage: 'Керування',
    tableForm: 'Форма',
    tableEdit: 'Редагувати',
    tableActions: 'Дії',
    manage: 'Керування',
    form: 'Форма',
    inactiveLabel: 'Неактивне',
    ubyportUnavailableTitle: 'Ubyport наразі недоступний.',
    ubyportUnavailableBody: 'Реєстрацію гостей наразі неможливо подати. Система автоматично повторить невдалі спроби.',
    statusCompleted: 'ЗАВЕРШЕНО',
    statusIncomplete: 'НЕЗАВЕРШЕНО',
    statusDeprecated: 'АРХІВОВАНО',
    statusNotFilled: 'НЕ ЗАПОВНЕНО',
    statusSent: 'НАДІСЛАНО',
    statusSending: 'НАДСИЛАННЯ',
    statusFailed: 'ПОМИЛКА',
    statusUnavailable: 'НЕДОСТУПНО',
    statusPartial: 'ЧАСТКОВО',
    statusNotSent: 'НЕ НАДІСЛАНО',
    cityTaxPaidLabel: 'Сплачено',
    cityTaxUnpaidLabel: 'Не сплачено',
    errorInactiveForm: 'Це бронювання неактивне через конфлікт. Спершу активуйте його на сторінці Конфліктів.',
    errorNoFormUrl: 'Неможливо відкрити URL форми для цього бронювання.',
    cancelledLabel: 'Скасовано',
    deprecatedLabel: 'Застаріло',
    dateLocale: 'uk-UA',
    emptyNoApartmentsTitle: 'Ласкаво просимо до Guestbook!',
    emptyNoApartmentsBody: 'У вас ще немає апартаментів. Додайте перший апартамент, щоб розпочати приймати бронювання та керувати гостями.',
    emptyNoApartmentsCta: 'Додати перший апартамент →',
    calendarSyncHint: 'Порада: Синхронізуйте календар бронювань (Airbnb, Booking.com…) і бронювання з\'являться автоматично.',
    calendarSyncLink: 'Налаштування календаря →',
  },
};
